import { render, staticRenderFns } from "./ModalEditPage.vue?vue&type=template&id=3fa16d28&scoped=true&"
import script from "./ModalEditPage.vue?vue&type=script&lang=js&"
export * from "./ModalEditPage.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditPage.vue?vue&type=style&index=0&id=3fa16d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa16d28",
  null
  
)

export default component.exports